import { AnyAction } from "redux";
import { actionCreatorFactory } from "typescript-fsa";

import { Activity, ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { NotificationActions } from "@com.mgmtp.a12.client/client-core/lib/core/notification";

import { localizableFromLocaleResources, RESOURCE_KEYS } from "../localization";
import { CustomNotification } from "../types/notification";

import ActivityActionPayload = ActivityActions.ActivityActionPayload;

const factory = actionCreatorFactory("MODULF");

export const handleEscape = factory<void>("HANDLE_ESCAPE");

export const addDataHolder = factory<AddDataHolderAction>("ADD_DATAHOLDER");
export interface AddDataHolderAction extends ActivityActionPayload {
	readonly dataHolder: Activity.DataHolder;
}

export const removeDataHolder = factory<RemoveDataHolderPayload>("REMOVE_DATA_HOLDER");
interface RemoveDataHolderPayload extends ActivityActions.ActivityActionPayload {
	readonly defaultDescriptor: Activity.Descriptor;
}

export function createCustomNotificationAction(payload: CustomNotification): AnyAction {
	const title =
		!payload.title && payload.severity
			? localizableFromLocaleResources(RESOURCE_KEYS.features.notification.title[payload.severity])
			: payload.title;
	return NotificationActions.add({ ...payload, title });
}
